module.exports = __webpack_public_path__ + "static/media/SudOuest.a841d970.jpg";